import * as yup from "yup";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormSwitch from "../../../../../../../shared/components/switch/FormSwitch";
import FormInput from "../../../../../../../shared/components/input/FormInput";

const EditPagesPermissionsForm = ({ onSubmitHandler, pageRoute }) => {
  const validationSchema = yup.object({});

  const defaultValues = {
    path: pageRoute?.path,
    hasAccess: pageRoute?.hasAccess,
    canCreate: pageRoute?.canCreate,
    canEdit: pageRoute?.canEdit,
    canDelete: pageRoute?.canDelete,
  };

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      isCreationForm={false}
    >
      <FormInput name="path" label="Ruta de acceso" disabled />
      <FormSwitch name="hasAccess" label="Permitir acceso" />
      <FormSwitch name="canCreate" label="Permitir creación" />
      <FormSwitch name="canEdit" label="Permitir edición" />
      <FormSwitch name="canDelete" label="Permitir borrado" />
    </BaseForm>
  );
};

export default EditPagesPermissionsForm;
